'use client'

import connectStats, {
  type StatsConnectorParams,
  type StatsWidgetDescription,
} from 'instantsearch.js/es/connectors/stats/connectStats'
import { useConnector } from 'react-instantsearch-hooks-web'

type UseStatsProps = StatsConnectorParams

function useStats(props?: UseStatsProps) {
  return useConnector<StatsConnectorParams, StatsWidgetDescription>(
    connectStats,
    props
  )
}

export function Stats(props: UseStatsProps) {
  const { hitsPerPage, nbHits, page } = useStats(props)

  return (
    <div className="mb-6 text-neutral-600">
      {nbHits > 0 && (
        <>
          Showing {page * (hitsPerPage || 0) + 1} -{' '}
          {(page + 1) * (hitsPerPage || 0)} out of {nbHits}
        </>
      )}

      {nbHits <= 0 && <div>no results</div>}
    </div>
  )
}
